import React from "react";
import BAddPage from "../../../components/crud/BAddPage";
import { coworkersService } from "../../../service/coworkersService";
import { entities } from "../../../utilis/entitiesNames";

export default function CoworkerAddPage() {
  return <BAddPage name={entities.COWORKERS} service={coworkersService} />;
}
